import { useEffect, useState } from "react";

import { Select, TextField, Typography } from "@king-ict/eupisi-ui/components";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import {
  ParentNoteFormCard,
  EnrollmentInstitutionFormCard,
} from "./components";
import { getInstitutionById } from "../../api/Institution/InstitutionApi";
import { getSchoolYearList } from "../../api/SchoolYear/SchoolYearApi";
import { ContentArea, FormCard, ToolbarTop } from "../../components";
import { useAuth } from "../../hooks/auth/useAuth";
import { Role, SchoolYear } from "../../models";
import { ImportantDateEventEnum } from "../../models/ImportantDate/ImportantDateEventEnum";
import {
  InstitutionLanguageModel,
  Institution,
  InstitutionProgram,
} from "../../models/Institution";
import { ClaimType } from "../../models/User";
import { institutionEditUrl, institutionListRoute } from "../../routes/routes";

export function InstitutionDetails() {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const auth = useAuth();

  const createInitialInstitutionDetails = (): Institution => {
    return {
      id: 0,
      //Naziv ustanove
      name: "",
      //Šifra ustanove
      code: "",
      //Podšifra istanove
      subCode: "",
      //schoolYearId: 0,
      //Županija sjedišta
      //countyName: "",
      //Općina/Grad sjedišta
      //municipalityName: "",
      //Naselje sjedišta
      //townName: "",
      //Adresa sjedišta
      //address1: "",
      //Lokacije ustanove izvan adrese sjedišta
      //address2: "",
      //OIB ustanove
      oib: "",
      isSatellite: false,
      status: "",
      isByEnrollmentArea: false,
      isHandicapped: false,
      isPrivateInstitution: false,
      address: {
        houseNumber: "",
        street: "",
        town: "",
        municipality: "",
        county: "",
      },
      //Tip ustanove
      //typeName: "",
      //Programi
      programs: [],
      //Izborni predmeti
      electiveSubjects: [],
      //Obvezni strani jezik
      mandatoryForeignLanguages: [],
      //Nastava na stranom jeziku
      foreignLanguages: [],
      //Produženi boravak
      //extendedStayClass: false,
      //Cjelodnevna nastava
      //allDayClass: false,
      //Organizacija rada u smjenama
      //shift: "",
      //Jezik nacionalne manjine
      //nationalMinorityLanguages: [],
      //Model
      languageSchoolingModels: [],
      institutionSchoolYearOtherArray: [],
      cds: false,
      tur: false,
      isReligious: false,
      isMinority: false,
    };
  };

  const [institutionDetails, setInstitutionDetails] = useState<Institution>(
    () => createInitialInstitutionDetails()
  );
  const [schoolYears, setSchoolYears] = useState<SchoolYear[]>();
  const [selectedschoolYear, setSelectedSchoolYear] = useState<number | null>();
  const [isActiveSchoolYear, setIsActiveSchoolYear] = useState(true);

  useEffect(() => {
    const _setInstitutionDetails = async () => {
      const schoolYearList = await getSchoolYearList();
      setSchoolYears(schoolYearList);
      const currentSchoolYear = schoolYearList.find((val) => val.isCurrent);
      let isEditable = false;
      if (currentSchoolYear) {
        const eventId =
          ImportantDateEventEnum.InstitutionAdministration as number;
        const importantDate = currentSchoolYear.importantDates.find(
          (val) => val.eventId === eventId
        );
        if (importantDate) {
          const exactlyNow = new Date(Date.now());
          const dateFrom = new Date(importantDate.dateTimeFrom);
          const dateTo = new Date(importantDate.dateTimeTo);
          if (dateFrom <= exactlyNow && dateTo >= exactlyNow) {
            isEditable = true;
          }
        }
        setSelectedSchoolYear(currentSchoolYear.id);
      }
      setIsActiveSchoolYear(isEditable);

      let results = null;

      if (id && selectedschoolYear) {
        results = await getInstitutionById(+id, selectedschoolYear);
      }

      if (results) {
        setInstitutionDetails(results);
      }
    };
    _setInstitutionDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    (async () => {
      let results = null;
      if (id && selectedschoolYear) {
        results = await getInstitutionById(+id, selectedschoolYear);
      }

      if (results) {
        setInstitutionDetails(results);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedschoolYear]);

  const handleSchoolYearChange = (e: any) => {
    const newSchoolYearId = Number.parseInt(e.target.value);
    const schoolYear = schoolYears?.find(
      (val) => val.isCurrent && val.id === newSchoolYearId
    );
    const eventId = ImportantDateEventEnum.InstitutionAdministration as number;
    let isEditable = false;
    if (schoolYear && schoolYear.isCurrent) {
      const importantDate = schoolYear.importantDates.find(
        (val) => val.eventId === eventId
      );
      if (importantDate) {
        const exactlyNow = new Date(Date.now());
        const dateFrom = new Date(importantDate.dateTimeFrom);
        const dateTo = new Date(importantDate.dateTimeTo);
        if (dateFrom <= exactlyNow && dateTo >= exactlyNow) {
          isEditable = true;
        }
      }
    }
    setSelectedSchoolYear(newSchoolYearId);
    setIsActiveSchoolYear(isEditable);
  };

  const handleEditButton = async () => {
    if (id) {
      history.push(institutionEditUrl(+id!));
    }
  };
  const getInstitutionProgramsListItems = (list: InstitutionProgram[]) => {
    if (list && list.length > 0) {
      return (
        <div>
          {list
            .filter((val) => val.isEnrollmentModule)
            .map((listItem) => (
              <Typography variant="medium" color="base">
                {listItem.name}
              </Typography>
            ))}
        </div>
      );
    }
  };

  const getInstitutionLanguageModelsListItems = (
    list: InstitutionLanguageModel[]
  ) => {
    if (list && list.length > 0) {
      return (
        <div>
          {list.map(
            (listItem) =>
              listItem.isEnrollmentModule && (
                <Row>
                  <Col md={3}>
                    <Typography variant="medium" color="base">
                      {listItem.languageName}
                    </Typography>
                  </Col>
                  <Col md={3}>
                    <Typography variant="medium" color="base">
                      {listItem.modelName}
                    </Typography>
                  </Col>
                </Row>
              )
          )}
        </div>
      );
    }
  };

  const getListItems = (list: string[]) => {
    if (list && list.length > 0) {
      return (
        <div>
          {list.map((listItem) => (
            <Typography variant="medium" color="base">
              {listItem}
            </Typography>
          ))}
        </div>
      );
    }
  };
  const goBack = () => {
    history.push(institutionListRoute);
  };

  const allowedRolesToEdit = [
    Role.CAS,
    Role.Helpdesk,
    Role.CountyAdministrator,
    Role.CountyLeader,
  ];

  return (
    <ContentArea>
      <ToolbarTop
        pageTitle={t("common.institutionDetails.institutionDetailsInfo")}
        showBack={"show"}
        showEdit={
          isActiveSchoolYear &&
          (allowedRolesToEdit.includes(auth.currentRole?.role || 0) ||
            auth.currentRole?.claimType === ClaimType.Institution)
            ? "show"
            : "disable"
        }
        onClickBack={goBack}
        onClickEdit={handleEditButton}
      />
      <FormCard cardTitle={t("common.institutionDetails.institutiBasicInfo")}>
        <Row>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.name")}
              value={institutionDetails.name}
              readonly
              plaintext
            />
          </Col>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.code")}
              value={institutionDetails.code}
              readonly
              plaintext
            />
          </Col>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.subCode")}
              value={institutionDetails.subCode}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.oib")}
              value={institutionDetails.oib || ""}
              readonly
              plaintext
            />
          </Col>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.countyName")}
              value={institutionDetails.address?.county}
              readonly
              plaintext
            />
          </Col>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.address1")}
              value={institutionDetails.address?.street}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <TextField
              label={t("common.institutionDetails.status")}
              value={institutionDetails.status || ""}
              readonly
              plaintext
            />
          </Col>
          <Col md={3}>
            <TextField
              label={t("common.institutionDetails.isByEnrollmentArea")}
              value={
                institutionDetails.isByEnrollmentArea
                  ? t("common.yes").toString()
                  : t("common.no").toString()
              }
              readonly
              plaintext
            />
          </Col>
          <Col md={2}>
            <TextField
              label={t("common.institutionList.satellite")}
              value={
                institutionDetails.isSatellite
                  ? t("common.yes").toString()
                  : t("common.no").toString()
              }
              readonly
              plaintext
            />
          </Col>
          <Col md={2}>
            <TextField
              label={t("common.institutionList.handicapped")}
              value={
                institutionDetails.isHandicapped
                  ? t("common.yes").toString()
                  : t("common.no").toString()
              }
              readonly
              plaintext
            />
          </Col>
          <Col md={2}>
            <TextField
              label={t("common.institutionList.private")}
              value={
                institutionDetails.isPrivateInstitution
                  ? t("common.yes").toString()
                  : t("common.no").toString()
              }
              readonly
              plaintext
            />
          </Col>
        </Row>
      </FormCard>
      <FormCard
        cardTitle={t("common.institutionDetails.institutionDetailsSchoolYear")}
      >
        <Row>
          <Col md={6}></Col>
          <Col md={6}>
            <Select
              label={t("common.institutionDetails.schoolYear")}
              value={selectedschoolYear}
              onChange={handleSchoolYearChange}
              selectData={codeBookToSelectData(schoolYears)}
            />
          </Col>
        </Row>
      </FormCard>
      <FormCard
        cardTitle={t("common.institutionDetails.institutionDetailsPrograms")}
      >
        <Row>
          <Col md={6}>
            {getInstitutionProgramsListItems(institutionDetails.programs)}
          </Col>
        </Row>
      </FormCard>
      <FormCard
        cardTitle={t("common.institutionDetails.institutionDetailsOther")}
      >
        <Row>
          <Col md={4}>
            <label className="BaseField_textLabel__zmFDV    form-label">
              {t("common.institutionDetails.izborniPredmeti")}
            </label>
            {getListItems(
              institutionDetails.electiveSubjects.map((val) => val.name)
            )}
          </Col>
          <Col md={4}>
            <label className="BaseField_textLabel__zmFDV    form-label">
              {t("common.institutionDetails.obavezniStraniJezik")}
            </label>
            {getListItems(
              institutionDetails.mandatoryForeignLanguages.map(
                (val) => val.name
              )
            )}
          </Col>
          <Col md={4}>
            <label className="BaseField_textLabel__zmFDV    form-label">
              {t("common.institutionDetails.straniJezici")}
            </label>
            {getListItems(
              institutionDetails.foreignLanguages?.map((val) => val.name) || []
            )}
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.extendedStayClass")}
              value={
                institutionDetails.institutionSchoolYearOther?.extendedStayClass
                  ? t("common.yes").toString()
                  : t("common.no").toString()
              }
              readonly
              plaintext
            />
          </Col>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.allDayClass")}
              value={
                institutionDetails.institutionSchoolYearOther?.allDayClass
                  ? t("common.yes").toString()
                  : t("common.no").toString()
              }
              readonly
              plaintext
            />
          </Col>
          <Col md={4}>
            <TextField
              label={t("common.institutionDetails.shift")}
              value={institutionDetails.institutionSchoolYearOther?.shift?.name}
              readonly
              plaintext
            />
          </Col>
        </Row>

        <Row>
          <Col md={8}>
            <label className="BaseField_textLabel__zmFDV    form-label">
              {t("common.institutionDetails.nationalMinorityLanguages")}
            </label>
            {getInstitutionLanguageModelsListItems(
              institutionDetails.languageSchoolingModels || []
            )}
          </Col>
          <Col md={4}>
            <TextField
              label={t("common.institutionEdit.activeForEnrollment")}
              value={
                institutionDetails.institutionSchoolYearOther
                  ?.activeForEnrollment
                  ? t("common.yes").toString()
                  : t("common.no").toString()
              }
              readonly
              plaintext
            />
          </Col>
        </Row>
      </FormCard>
      <EnrollmentInstitutionFormCard
        isReligious={institutionDetails.isReligious}
        isMinority={institutionDetails.isMinority}
        enrollmentInstitution={
          institutionDetails.institutionSchoolYearOther?.enrollmentInstitution
        }
        readonly
      />
      <ParentNoteFormCard
        value={institutionDetails.institutionSchoolYearOther?.remark || ""}
        readonly
      />
      <FormCard
        cardTitle={t("common.institutionDetails.institutionContactDetails")}
      >
        <Row>
          <Col md={4}>
            <TextField
              label={t("common.phone")}
              value={
                institutionDetails.institutionSchoolYearOther
                  ?.telephoneNumber || ""
              }
              readonly
              plaintext
            />
          </Col>
          <Col md={4}>
            <TextField
              label={t("common.email")}
              value={institutionDetails.institutionSchoolYearOther?.email || ""}
              readonly
              plaintext
            />
          </Col>
        </Row>
      </FormCard>
    </ContentArea>
  );
}
